module.exports = __webpack_public_path__ + "static/media/socialMediaMarketing.d83166dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/Teafloor/socialMediaMarketing.jpg
// module id = 367
// module chunks = 0